import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { PLANT_CLASSIFICATION } from '../../constants/routes'
import { resetClassifyImage, setClassifyImage } from '../../actions'
import {
    MediaWrapper,
    GalleryUploadImageIcon,
    TrashIcon,
    ClassifierActionsBar,
    TakeScreenshotButtonWrapper,
    TakeScreenshotButton,
    UploadImageIcon,
    UploadImageIconWrapper
} from '../StyledComponents/Classifier/Camera'

import InfoModal from '../Global/InfoModal'
import { FillerDiv } from '../StyledComponents/Fillers'

const searchPlantIcon = require('../../assets/images/Classifier/searchPlant.svg')

class ClassifierPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            stream: null,
            width: null,
            height: null,
            supportsCamera: true,
            showModal: true,
        }

        this.takeScreenshot = this.takeScreenshot.bind(this)
        this.playVideo = this.playVideo.bind(this)
        this.stopVideo = this.stopVideo.bind(this)
        this.onImageUpload = this.onImageUpload.bind(this)
        this.resetImage = this.resetImage.bind(this)
        this.onImageClassify = this.onImageClassify.bind(this)
    }

    componentDidMount() {
        this.video.addEventListener('loadedmetadata', () => {
            const ratio = this.video.videoWidth / this.video.videoHeight
            const w = this.video.videoWidth - 100
            const h = parseInt(w / ratio, 10)

            this.setState({
                width: w,
                height: h,
            })
            this.canvas.width = w
            this.canvas.height = h
        }, false)

        if (!this.props.image) {
            this.playVideo()
        }
    }

    componentWillUnmount() {
        this.stopVideo()
    }

    onImageUpload(event) {
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader()
            reader.onload = (e) => {
                this.props.setClassifyImage(e.target.result)
                this.stopVideo()
            }
            this.props.resetClassifyImage()
            reader.readAsDataURL(event.target.files[0])
        }
    }

    onImageClassify() {
        this.props.history.push(PLANT_CLASSIFICATION)
    }

    resetImage() {
        this.playVideo()
        this.props.resetClassifyImage()
    }

    playVideo() {
        if (!this.state.stream) {
            const constraints = {
                audio: false,
                video: {
                    facingMode: 'environment',
                },
            }

            if (typeof navigator.mediaDevices !== 'undefined') {
                this.setState({ supportsCamera: true })
                navigator.mediaDevices.getUserMedia(constraints)
                    .then((stream) => {
                        this.setState({
                            stream,
                        })
                        this.video.srcObject = stream
                    })
                    .catch(e => console.error(e))
            } else {
                this.setState({ supportsCamera: false })
            }
        }
    }

    stopVideo() {
        if (this.state.stream) {
            const { stream } = this.state
            stream.getTracks().forEach(track => track.stop())
            this.setState({
                stream: null,
            })
        }
    }

    takeScreenshot() {
        const { width, height, stream } = this.state

        if (stream) {
            const context = this.canvas.getContext('2d')
            context.fillRect(0, 0, width, height)
            context.drawImage(this.video, 0, 0, width, height)
            this.props.setClassifyImage(this.canvas.toDataURL())
            this.stopVideo()
        }
    }

    render() {
        const { image, history, model } = this.props
        const hasImage = image && image.length > 0

        const sceenshot = <img style={{ width: '100%', backgroundSize: 'cover', display: `${hasImage ? 'block' : 'none'}` }} src={image} alt="screenshot" />
        const videoElem = <video style={{ width: '100%', display: `${hasImage ? 'none' : 'block'}` }} muted ref={(video) => { this.video = video }} autoPlay playsInline />

        const mainAction = hasImage
            ? (
                <UploadImageIconWrapper onClick={this.onImageClassify}>
                    <UploadImageIcon src={searchPlantIcon} />
                </UploadImageIconWrapper>
            )
            : (
                <TakeScreenshotButtonWrapper onClick={this.takeScreenshot}>
                    <TakeScreenshotButton />
                </TakeScreenshotButtonWrapper>
            )

        const noCameraSupportMsg = this.state.supportsCamera || hasImage ? null : (
            <div style={{ textAlign: 'center' }}>
                {'Live Kamera Input wird in einigen Betriebssystemen für Progressive Web Apps nicht unterstützt.'}
                <br />
                {'Verwende die Bild Upload Funktion unten rechts oder versuche die Seite im Browser zu öffnen.'}
                <br />
                <a href="https://webapp.flowerai.de">https://webapp.flowerai.de</a>
            </div>
        )

        const mlWarning = this.state.showModal && !model ? (<InfoModal
            text="Wenn du ein Foto klassifizieren lassen willst, musst du unser Machine Learning Model laden. Dieses ist ca. 100MB groß. Wir empfehlen daher die Klassifizierung nur mit einer WLAN Verbindung zu verwenden, um das mobile Datenvolumen nicht zu belasten."
            headerText="Achtung"
            isOpen
            actionText="Abbrechen"
            secondaryText="Weiter"
            closeModal={() => {
                this.setState({ showModal: false })
                history.goBack()
            }}
            secondaryAction={() => this.setState({ showModal: false })}
        />) : null

        return (
            <MediaWrapper>
                {mlWarning}
                {noCameraSupportMsg}
                {videoElem}
                {sceenshot}
                <canvas style={{ display: 'none' }} ref={(canvas) => { this.canvas = canvas }} />

                <ClassifierActionsBar>
                    <TrashIcon color={hasImage ? '#fff' : 'var(--secondary)'} name="trash" size="2x" onClick={this.resetImage} />
                    {mainAction}
                    <FillerDiv>
                        <label htmlFor="file-input">
                            <GalleryUploadImageIcon name="image" size="2x" />
                        </label>
                        <input style={{ display: 'none' }} id="file-input" type="file" accept="image/*" onChange={this.onImageUpload} />
                    </FillerDiv>
                </ClassifierActionsBar>
            </MediaWrapper>
        )
    }
}

const mapStateToProps = state => ({
    image: state.classifier.image,
    model: state.tensorflowModel.model,
})

export default compose(
    withRouter,
    connect(mapStateToProps, { resetClassifyImage, setClassifyImage })
)(ClassifierPage)



// WEBPACK FOOTER //
// ./src/components/pages/Classifier.js